import React from 'react';

const TransmissionLineMapCard = ({ title, description, headerControls = null, children }) => (
  <div
    className="bg-white rounded-lg hover:shadow-sm transition-shadow w-full min-w-0 overflow-hidden"
    description={description}
  >
    <div className="flex flex-wrap justify-between items-start gap-2 p-2 sm:p-3 md:p-4">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 min-w-0">
        <div className="min-w-0">
          <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-0 sm:mb-1">{title}</h3>
        </div>
        {headerControls}
      </div>
    </div>
    <div className="chart-container w-full min-w-0">
      <div className="relative w-full min-h-[260px] h-[42vh] sm:h-[45vh] md:h-[500px] max-h-[500px]">
        {children}
      </div>
    </div>
  </div>
);

export default TransmissionLineMapCard;
